import { render, staticRenderFns } from "./stockc.vue?vue&type=template&id=c4c87f68&scoped=true&"
import script from "./stockc.vue?vue&type=script&lang=js&"
export * from "./stockc.vue?vue&type=script&lang=js&"
import style0 from "./stockc.vue?vue&type=style&index=0&id=c4c87f68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c87f68",
  null
  
)

export default component.exports